// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1zTHJ","row":"styles_row___rJxJ"};